import Permission from '@/api/setting/Permission'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    total: 0,
    data: [],
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
      state.total = data.total
    },
  },
  actions: {
    datatable({commit}, params) {
      return Permission.datatable(params).then(res => {
        commit('SET_DATA', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    detail({}, id) {
      return Permission.detail(id).then(res => {
        const {data} = res.data.message
        return data
      }).catch(error => {
        // Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    store({}, data) {
      return Permission.store(data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    update({}, {id, ...data}) {
      return Permission.update(id, data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    delete({}, id) {
      return Permission.delete(id).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    isDefault({}, privilege) {
      return Permission.isDefault(privilege).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    }
  },
  getters: {}
}
